// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"81":"005cc72d","394":"c93683d7","410":"ec837c64","481":"3f30ccb1","946":"506e4184"}[chunkId] + ".chunk.css");